import React from "react"

const Avatar = React.memo(props => {
    const user = props.user
    let text = props.forcetext || ""
    if (user) {
        text = [user.get("firstname"), user.get("lastname")]
            .filter(v => !!v)
            .map(v => v.substring(0, 1))
            .join("")
        if (!text) {
            text = user.get("email").substring(0, 1)
        }
    }

    let img = ""
    if (props.forceimg) img = props.forceimg

    if (img) {
        return (
            <div className={`avatar ${props.className ? props.className : ""}`}>
                <img alt={text.toUpperCase()} src={img} />
            </div>
        )
    }

    return <div className={`avatar ${props.className ? props.className : ""}`}>{text.toUpperCase()}</div>
})

export default Avatar
